var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.259,
    height: 79.428,
    viewBox: "0 0 70.259 79.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rubik_1_",
    "data-name": "rubik (1)",
    transform: "translate(0.511 0.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M37.12,78.277A1.12,1.12,0,0,1,36,77.157V39.2a1.12,1.12,0,0,1,.582-.982L70.02,19.892a1.12,1.12,0,0,1,1.659.982v37.96a1.12,1.12,0,0,1-.582.982L37.658,78.139a1.12,1.12,0,0,1-.538.138Zm1.12-38.415v35.4l31.2-17.1v-35.4Z",
    transform: "translate(-2.494 0.132)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M40.707,78.277a1.12,1.12,0,0,1-.538-.138L6.73,59.816a1.12,1.12,0,0,1-.582-.982V20.874a1.12,1.12,0,0,1,1.659-.982L41.244,38.216a1.12,1.12,0,0,1,.582.982V77.157A1.12,1.12,0,0,1,40.707,78.277ZM8.388,58.169l31.2,17.1v-35.4l-31.2-17.1Z",
    transform: "translate(-6.081 0.132)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M74.151,24.127a1.12,1.12,0,0,1-.571-.157L40.714,4.424,7.848,23.97A1.12,1.12,0,1,1,6.7,22.051L40.142,2.158a1.12,1.12,0,0,1,1.145,0L74.724,22.051a1.12,1.12,0,0,1-.572,2.082Z",
    transform: "translate(-6.088 -2.001)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M57.047,69.419a1.12,1.12,0,0,1-1.12-1.1l-.633-36.965L22.849,12.238a1.12,1.12,0,1,1,1.136-1.929L56.891,29.7a1.12,1.12,0,0,1,.633.982l.644,37.6a1.12,1.12,0,0,1-1.1,1.139Z",
    transform: "translate(-4.145 -1.024)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M20.8,69.415h-.02a1.12,1.12,0,0,1-1.1-1.139l.644-37.6a1.12,1.12,0,0,1,.69-1.016L53.866,10.305A1.12,1.12,0,0,1,55,12.234L22.557,31.353l-.633,36.965a1.12,1.12,0,0,1-1.12,1.1Z",
    transform: "translate(-4.455 -1.02)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M40.436,59.654a1.113,1.113,0,0,1-.56-.149L6.71,40.443A1.121,1.121,0,0,1,7.83,38.5l32.6,18.741L73.581,37.9a1.12,1.12,0,1,1,1.128,1.93L41,59.5a1.12,1.12,0,0,1-.565.151Z",
    transform: "translate(-6.081 2.289)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIcon);
export default __webpack_public_path__ + "static/media/game_icon.e7f06a10.svg";
export { ForwardRef as ReactComponent };